module.exports = __webpack_public_path__ + "kidsDesktop.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/preview-popup/assets/kidsDesktop.png
// module id = 1181
// module chunks = 10